import { ReflectionRoleEnum } from './reflection-role-enum'

export interface ReceiverInterface {
  /**
   * 接收人名称
   */
  name?: string
  phone?: string
  role: ReflectionRoleEnum
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
}

export class Receiver implements ReceiverInterface {
  /**
   * 接收人名称
   */
  name?: string
  phone?: string
  role: ReflectionRoleEnum
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number

  constructor(props: ReceiverInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      name: _name,
      phone: _phone,
      role: _role,
      id: _id,
      schoolId: _schoolId,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.name = _name
    this.phone = _phone
    this.role = _role
    this.id = _id
    this.schoolId = _schoolId
  }
}
